import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Document, Page, pdfjs } from "react-pdf";
import CoverPhotoBaseURL from "../../../util/coverPhotoBaseURL";
import "./style.css";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function PdfReaderModal({ openModal, HideModal, item }) {
  const [tst, setTest] = useState("#toolbar=0");
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(0);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }
  function onNext() {
    if (pageNumber + 1 <= numPages) {
      setPageNumber(pageNumber + 1);
    }
  }
  function onPrevious() {
    if (pageNumber - 1 >= 1) {
      setPageNumber(pageNumber - 1);
    }
  }
  const handleChange = (value) => {
    if (value > 0) {
      console.log(value);
      //let x = e.target.value;
      setPageNumber(value);
    }
  };
  return (
    <>
      <Modal
        size="lg"
        backdrop="static"
        show={openModal}
        onHide={HideModal}
        centered
      >
        <button
          type="button"
          className="close custom-modal-close"
          onClick={HideModal}
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div className="read-form">
          {/* <div className="d-flex justify-content-center align-items-center pdf-search-input-field-container">
            <input
              type="number"
              className="pdf-search-input-field"
              onChange={(e) => handleChange(e.target.value)}
            />
            <label className="m-0">/{numPages}</label>
          </div> */}
          <div className="pdf-reader-container overflow-auto">
            <Document
              file={`${CoverPhotoBaseURL}${item?.file}`}
              onLoadError={console.error}
              onLoadSuccess={onDocumentLoadSuccess}
              onContextMenu={(e) => e.preventDefault()}
              className="pdf-remove-print"
            >
              <Page pageNumber={pageNumber} height={700} />
            </Document>
          </div>
        </div>
        <div className="d-flex justify-content-center align-items-center mb-3">
          <button className="make-offer-btn1" onClick={() => onPrevious()}>
            Previous
          </button>
          <button className="make-offer-btn1" onClick={() => onNext()}>
            Next
          </button>
        </div>
      </Modal>
    </>
  );
}

export default PdfReaderModal;
